import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsService } from '../constants.service';

@Injectable({
	providedIn: 'root'
})
export class PeriodsManageService {

	constructor(private readonly http : HttpClient, private readonly constantsService : ConstantsService) { }
	loadDataPeriods(): Observable<any> {

		return this.http
			.get(`${this.constantsService.baseAPIURL}/gihome/getPeriodsDate`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError)
			);
	}

	addPeriod(periodId, crossDockStart, crossDockEnd, midWestStart, midWestEnd, westCoastStart, westCoastEnd) {
		const InData  = {
			periodId: Number(periodId),
			crossDockStart: crossDockStart,
			crossDockEnd: crossDockEnd,
			midWestStart: midWestStart,
			midWestEnd: midWestEnd,
			westCoastStart: westCoastStart,
			westCoastEnd: westCoastEnd
		}
		return this.http.post(`${this.constantsService.baseAPIURL}/gihome/addPeriodsDate`, InData, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	editPeriod(periodId, crossDockStart, crossDockEnd, midWestStart, midWestEnd, westCoastStart, westCoastEnd) {
		const InData  = {
			periodId: Number(periodId),
			crossDockStart: crossDockStart,
			crossDockEnd: crossDockEnd,
			midWestStart: midWestStart,
			midWestEnd: midWestEnd,
			westCoastStart: westCoastStart,
			westCoastEnd: westCoastEnd
		}
		return this.http.post(`${this.constantsService.baseAPIURL}/gihome/editPeriodsDate`, InData, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	deletePeriod(periodId): Observable<any> {

		return this.http
			.delete(`${this.constantsService.baseAPIURL}/gihome/deletePeriodDate?periodId=${periodId}`, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	private handleError(error: HttpErrorResponse): Observable<never> {
		return throwError(() => error.message || 'Server Error');
	}


}